<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import {Button} from "@/components/ui/button"
import {ChevronLeft} from "lucide-vue-next"
import {OrgSelector} from '@/components/filters'
import {DialogCreateProject, DialogCreateOrg} from '@/components/dialogs'
import DialogUpdateOrg from './DialogUpdateOrg.vue'
import {API, HOST} from '@/utils/http'
import { toast } from '@/components/ui/toast'

const router = useRouter()
const store = useStore()
const member = computed(() => store.getters.getMember)

const stats = ref(null)

onMounted(async () => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/stats`
    })

    stats.value = response.data ? response.data : null
  } catch (error) {
    toast({
      title: `Failed to fetch stats: ${error.message}`
    })
  }
})

watch(() => member.value, (value) => {
  if (!value) {
    return
  }

  if (!value.is_super_user) {
    router.push({name: 'Dashboard'})
  }
})
</script>

<template>
  <div v-if="member && member.is_super_user">
    <div class="px-3 pt-3">
      <div class="mb-3">
        <h3 class="font-bold">Stats</h3>
        <div>
          <ul v-if="stats">
            <li>Total orgs: {{ stats.total_organizations }}</li>
            <li>Total projects: {{ stats.total_projects }}</li>
            <li>Total users: {{ stats.total_members  }}</li>
          </ul>
        </div>
      </div>

      <div class="space-y-3">
        <h3 class="font-bold">Organizations</h3>
        <div>
          <DialogCreateOrg>
            <Button variant="secondary" size="sm">+ Add organization</Button>
          </DialogCreateOrg>
        </div>
        <div>
          <org-selector v-if="$route.name !== 'Organizations'" />
        </div>
        <div>
          <DialogUpdateOrg></DialogUpdateOrg>
        </div>
      </div>
      <div class="mt-3">
        <h3 class="font-bold mb-1">Projects</h3>
        <DialogCreateProject>
          <Button variant="secondary" size="sm">+ Add root/master project</Button>
        </DialogCreateProject>
      </div>
    </div>
  </div>
</template>
